{
  "name": "@replit/river",
  "description": "It's like tRPC but... with JSON Schema Support, duplex streaming and support for service multiplexing. Transport agnostic!",
  "version": "0.223.0",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/replit/river.git"
  },
  "type": "module",
  "exports": {
    ".": "./dist/router/index.js",
    "./logging": "./dist/logging/index.js",
    "./protobuf": "./dist/protobuf/index.js",
    "./protobuf/codec": "./dist/protobuf/codec.js",
    "./codec": "./dist/codec/index.js",
    "./transport": "./dist/transport/index.js",
    "./transport/ws/client": "./dist/transport/impls/ws/client.js",
    "./transport/ws/server": "./dist/transport/impls/ws/server.js",
    "./test-util": "./dist/testUtil/index.js",
    "./customSchemas": "./dist/customSchemas/index.js"
  },
  "sideEffects": [
    "./dist/logging/index.js"
  ],
  "files": [
    "dist"
  ],
  "dependencies": {
    "@bufbuild/protobuf": "^2.11.0",
    "@msgpack/msgpack": "^3.1.2",
    "nanoid": "^5.0.9",
    "ws": "^8.17.0"
  },
  "peerDependencies": {
    "@opentelemetry/api": "^1.7.0",
    "typebox": "^1.1.0"
  },
  "devDependencies": {
    "@bufbuild/buf": "^1.67.0",
    "@hegeldev/hegel": "^0.4.5",
    "@opentelemetry/api": "^1.7.0",
    "@opentelemetry/context-async-hooks": "^1.26.0",
    "@opentelemetry/core": "^1.7.0",
    "@opentelemetry/sdk-trace-base": "^1.24.1",
    "@stylistic/eslint-plugin": "^2.6.4",
    "@types/ws": "^8.5.5",
    "@typescript-eslint/eslint-plugin": "^7.8.0",
    "@typescript-eslint/parser": "^7.8.0",
    "@vitest/ui": "^3.2.6",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "prettier": "^3.0.0",
    "tsup": "^8.4.0",
    "typebox": "^1.1.38",
    "typescript": "^5.4.5",
    "vitest": "^3.2.6"
  },
  "scripts": {
    "check": "tsc --noEmit && npm run format && npm run lint",
    "format": "npx prettier . --check",
    "format:fix": "npx prettier . --write",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "fix": "npm run format:fix && npm run lint:fix",
    "proto:generate": "buf generate --template buf.gen.yaml --clean --path proto/transport.proto && buf generate --template buf.gen.test.yaml --clean --path proto/test/test_service.proto",
    "build": "rm -rf dist && tsup && du -sh dist",
    "prepack": "npm run build",
    "release": "npm publish --access public",
    "test:ui": "echo \"remember to go to /__vitest__ in the webview\" && vitest --ui --api.host 0.0.0.0 --api.port 3000",
    "test": "vitest",
    "test:single": "vitest run --reporter=dot",
    "test:flake": "./flake.sh",
    "bench": "vitest bench"
  },
  "engines": {
    "node": ">=20.11.0"
  },
  "keywords": [
    "rpc",
    "websockets",
    "jsonschema"
  ],
  "author": "Jacky Zhao",
  "license": "MIT"
}
